import { BOT } from '../constants/RoutingTypes';
import RoutingRuleBase from './RoutingRuleBase';
const BotRoutingRules = RoutingRuleBase({
  '@type': BOT,
  botId: null
}, 'BotRoutingRules');
export const buildBotRoutingRules = options => new BotRoutingRules(options);
export default BotRoutingRules;